import { render } from "./masterKPI.vue?vue&type=template&id=b412a094&scoped=true&ts=true"
import script from "./masterKPI.vue?vue&type=script&lang=ts"
export * from "./masterKPI.vue?vue&type=script&lang=ts"

import "./masterKPI.vue?vue&type=style&index=0&id=b412a094&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b412a094"]])

export default __exports__